export type StepHeaderType =
  | 'onboarding'
  | 'onboardingMultipleProducts'
  | 'adpOnboarding'
  | 'defaultOffboarding'
  | 'addPackage'
  | 'investmentLineup';

export const StepSequences: Record<StepHeaderType, string[]> = {
  onboarding: ['About your org', 'Admins', 'Licenses', 'Contract'],
  onboardingMultipleProducts: ['About your org', 'Admins', 'Product', 'Licenses', 'Contract'],
  adpOnboarding: ['Deductions', 'Contract'],
  defaultOffboarding: ['Logo', 'Custom blurb', 'Invite members'],
  addPackage: ['Package', 'Contract'],
  investmentLineup: ['Plan basics', 'Employer contributions', 'Member contributions'],
};
